/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameDisplayOrder } from './GameDisplayOrder';
import {
    GameDisplayOrderFromJSON,
    GameDisplayOrderFromJSONTyped,
    GameDisplayOrderToJSON,
} from './GameDisplayOrder';

/**
 * The positions now stored, echoing back what the request assigned.
 * @export
 * @interface GameDisplayOrders
 */
export interface GameDisplayOrders {
    /**
     * 
     * @type {Array<GameDisplayOrder>}
     * @memberof GameDisplayOrders
     */
    items: Array<GameDisplayOrder>;
}

/**
 * Check if a given object implements the GameDisplayOrders interface.
 */
export function instanceOfGameDisplayOrders(value: object): value is GameDisplayOrders {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GameDisplayOrdersFromJSON(json: any): GameDisplayOrders {
    return GameDisplayOrdersFromJSONTyped(json, false);
}

export function GameDisplayOrdersFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameDisplayOrders {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GameDisplayOrderFromJSON)),
    };
}

export function GameDisplayOrdersToJSON(value?: GameDisplayOrders | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(GameDisplayOrderToJSON)),
    };
}

